import logo from "@/assets/alm-logo.png";
import loginHero from "@/assets/login-hero.jpg";

// Single source of truth for product branding.
// Change these values (or the imported assets) to rebrand the whole app.
export const BRANDING = {
  productName: "K9 Manager",
  productSignature: "by ALM",
  subtitle: "Gestione professionale per attività cinofile",
  logo,
  loginHero,
};
